import CustomIcon from "../../components/CustomIcon";
import * as React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
} from "react-native";
import { ScrollView, TextInput } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Auth } from "aws-amplify";
import { updateUserProfileData, user_force_refresh } from "../../redux/actions/UserActions";
{/* This commented part can be removed in 17/10/23 */ }
// import FooterBarWide from "../../components/footerBarWide";
// import MenuBar from "../../components/headers/MenuBar";
// import StatusBar from "../../components/headers/StatusBar";
import { useSelector } from "react-redux";
import GenericButton from "../../components/GenericButton.js";
import Colors from "../../utilities/Color.js";

export default function SettingsProfileScreen() {
  const navigation = useNavigation();
  const win = Dimensions.get("window");
  var once = 0;

  var setEmail = useSelector((state) => state.user.userData.subscriberDetails.email);
  var setFname = useSelector((state) => state.user.userData.subscriberDetails.familyName);
  var setGname = useSelector((state) => state.user.userData.subscriberDetails.givenName);
  var setPhone = useSelector(
    (state) => state.user.userData.subscriberDetails.phone
  );

  const [email, onChangeEmailText] = React.useState("");
  const [phone, onChangePhoneText] = React.useState("");
  const [givenName, onChangeGivenNameText] = React.useState("");
  const [familyName, onChangeFamilyNameText] = React.useState("");

  var isSetPhone = setPhone === 0 || setPhone === '0' || setPhone === '' || setPhone === undefined ? false : true;
  var isSetEmail = setEmail === 0 || setEmail === '0' || setEmail === '' || setEmail === undefined ? false : true;
  var isSetFname = setFname === undefined ? false : true;
  var isSetGname = setGname === undefined ? false : true;

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={win.width > 768 ? [GlobalStyles.adjustableBodyContainer, { justifyContent: 'center' }] : styles.bodyContainerT}>
        <View style={styles.formContainer}>
          <Text style={styles.TextStyleHeader}>My Account</Text>
          <Text style={styles.TextStyleBody}>
            Please take a moment to complete your profile.
          </Text>
          <View style={styles.formStyle}>
            {isSetGname === true ? (
              <View style={styles.inputBoxFaded}>
                <Text style={styles.textFaded}>{setGname}</Text>
              </View>
            ) : (
              <View style={styles.inputBox}>
                <TextInput
                  placeholder="First Name"
                  style={styles.textInput}
                  underlineColorAndroid="transparent"
                  value={givenName}
                  onChangeText={(text) => onChangeGivenNameText(text)}
                />
              </View>
            )}
            {isSetFname === true ? (
              <View style={styles.inputBoxFaded}>
                <Text style={styles.textFaded}>{setFname}</Text>
              </View>
            ) : (
              <View style={styles.inputBox}>
                <TextInput
                  placeholder="Last Name"
                  style={styles.textInput}
                  underlineColorAndroid="transparent"
                  value={familyName}
                  onChangeText={(text) => onChangeFamilyNameText(text)}
                />
              </View>
            )}
            {isSetEmail === true ? (
              <View style={styles.inputBoxFaded}>
                <Text style={styles.textFaded}>{setEmail}</Text>
              </View>
            ) : (
              <View style={styles.inputBox}>
                <TextInput
                  placeholder="Email"
                  style={styles.textInput}
                  underlineColorAndroid="transparent"
                  value={email}
                  onChangeText={(text) => onChangeEmailText(text)}
                />
              </View>
            )}
            {isSetPhone === true ? (
              <View style={styles.inputBoxFaded}>
                <Text style={styles.textFaded}>{setPhone}</Text>
              </View>
            ) : (
              <View style={styles.inputBox}>
                <TextInput
                  placeholder="Phone"
                  style={styles.textInput}
                  underlineColorAndroid="transparent"
                  value={phone}
                  onChangeText={(text) => onChangePhoneText(text)}
                />
              </View>
            )}
          </View>
          <View style={styles.buttonContainer}>
            {/* This commented part can be removed in 17/10/23 */}
            {/* <TouchableOpacity
              style={styles.SubmitButtonStyleBack}
              activeOpacity={0.5}
              onPress={() => navigation.goBack()}
            >
              <Text style={styles.TextStyle}>BACK</Text>
            </TouchableOpacity> */}
            <GenericButton
              buttonText='BACK'
              onPress={() => navigation.navigate("Settings")}
              buttonColor={null}
              buttonWidth={120}
              borderWidth={1}
              borderColor={Colors.DARKGRAY}
            />
            {/* This commented part can be removed in 17/10/23 */}
            {/* <TouchableOpacity
              style={styles.SubmitButtonStyleContinue}
              activeOpacity={0.5}
              onPress={() => {
                updateUserProfileData(givenName, familyName, phone, email);
                user_force_refresh();
                navigation.navigate("MainMenu");
              }}
            >
              <Text style={styles.TextStyle}>SAVE</Text>
            </TouchableOpacity> */}

            <GenericButton
              buttonColor={Colors.WHITE}
              buttonText='SAVE'
              onPress={() => {
                updateUserProfileData(givenName, familyName, phone, email);
                user_force_refresh();
                navigation.navigate("MainMenu");
              }}
              buttonWidth={120}
            />

          </View>
        </View>
        <View>
          <TouchableOpacity
            style={styles.SubmitButtonStyleToggle}
            activeOpacity={0.0}
            onPress={() => navigation.navigate("SettingsDebugMode")}
          >
            <Text style={styles.TextStyle}>T</Text>
          </TouchableOpacity></View>
        {/* <View><TouchableOpacity
              style={styles.SubmitButtonStyleWebview}
              activeOpacity={0.0}
              onPress={() => navigation.navigate("WebView")}
            >
              <Text style={styles.TextStyle}>Web View test</Text>
            </TouchableOpacity></View>*/}
      </View>
      <View style={GlobalStyles.webFooter}>
        {/* win.width > 768 ? <FooterBarWide /> : null */}
      </View>
    </View>
  );
}

function OptionButton({ icon, label, onPress, subtext, isLastOption }) {
  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          <CustomIcon name={icon} size={24} color="rgba(0,0,0,0.99)" />
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionSubtextContainer}>
          <Text style={styles.optionSubtext}>{subtext}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: 'center',
  },
  formStyle: {
    flexDirection: "column",
    width: "90%",
  },
  inputBox: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },
  inputBoxFaded: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#fee394",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    fontFamily: "montserrat-medium",
    fontSize: 11,
    textAlign: "left",
    paddingTop: 20,
    paddingBottom: 5,
  },
  buttonContainer: {
    flexDirection: "row",
    width: "100%",
    marginTop: 40,
    justifyContent: "space-evenly",
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },
  TextStyleHeader: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
  },
  formContainer: {
    alignContent: "center",
    backgroundColor: "#FFC72C",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 55,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    paddingBottom: 55,
    maxWidth: 800,
    alignSelf: "center",
  },
  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  SubmitButtonStyleBack: {
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    borderColor: "#000000",
    flex: 1,
    borderWidth: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },
  SubmitButtonStyleContinue: {
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },

  SubmitButtonStyleToggle: {
    borderRadius: 50,
    marginTop: 30,
    borderWidth: 1,
    color: "#000000",
    height: 20,
    width: 20,
    justifyContent: 'center',
    alignSelf: "center",
    opacity: 0,
  },
  SubmitButtonStyleWebview: {
    borderRadius: 50,
    marginLeft: 10,
    marginTop: 10,
    backgroundColor: "#FFFFFF",
    color: "#000000",
    height: 60,
    width: 209,
    justifyContent: 'center',
    alignSelf: "center",
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: 'none'
      }
    }),
    borderColor: "#CCCCCC",
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
  },
  textFaded: {
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    paddingTop: 7,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
    color: "#666666",
  },
  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },
  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },
  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },
  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },
  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },
  containerA: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },
  logoText: {
    paddingTop: 20,
  },
  smallLogo: {
    width: 107,
    height: 60,
    resizeMode: "contain",
  },
});
